import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { SparkleBackground } from '../components/ui/sparkle-background';

export function Login() {
  const { loginWithRedirect, isLoading } = useAuth0();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-pulse-glow rounded-full bg-primary/20 p-4">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      </div>
    );
  }

  return (
    <SparkleBackground className="min-h-screen bg-gradient-to-br from-background via-background to-muted">
      <div className="flex min-h-screen items-center justify-center p-4">
        <Card variant="glass" className="w-full max-w-md animate-fade-in-up">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl text-gradient-brand">{t('platform.title')}</CardTitle>
            <CardDescription>{t('platform.welcome')}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button className="w-full" size="lg" onClick={() => loginWithRedirect()}>
              Sign in
            </Button>
            <p className="text-center text-sm text-muted-foreground">
              Sign in to access your organization dashboard
            </p>
          </CardContent>
        </Card>
      </div>
    </SparkleBackground>
  );
}
